import { GiftCard } from '../../services/api';
import { GiftCardRow } from './GiftCardRow';
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from '../ui/table';
import { Checkbox } from '../ui/checkbox';
import { useEffect, useRef } from 'react';

interface GiftCardTableProps {
  giftCards: GiftCard[];
  onEdit: (card: GiftCard) => void;
  onViewTransactions?: (card: GiftCard) => void;
  getStatusLabel: (status: string) => string;
  getStatusClass: (status: string) => string;
  isBulkMode?: boolean;
  selectedIds?: Set<string>;
  onSelect?: (id: string, selected: boolean) => void;
  onSelectAll?: (selected: boolean) => void;
}

export function GiftCardTable({ giftCards, onEdit, onViewTransactions, getStatusLabel, getStatusClass, isBulkMode, selectedIds, onSelect, onSelectAll }: GiftCardTableProps) {
  if (giftCards.length === 0) {
    return <div className="text-center py-10 text-muted-foreground">Сертификаты не найдены</div>;
  }

  const allSelected = isBulkMode && giftCards.length > 0 && giftCards.every(card => selectedIds?.has(card.id));
  const someSelected = isBulkMode && giftCards.some(card => selectedIds?.has(card.id));
  const selectAllCheckboxRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (selectAllCheckboxRef.current) {
      (selectAllCheckboxRef.current as any).indeterminate = someSelected && !allSelected;
    }
  }, [someSelected, allSelected]);

  return (
    <div className="border rounded-lg overflow-hidden">
      <div className="overflow-x-auto">
        <div className="max-h-[60vh] overflow-y-auto">
          <Table>
            <TableHeader className="sticky top-0 bg-background z-10">
              <TableRow>
                {isBulkMode && (
                  <TableHead className="w-[50px]">
              <Checkbox
                ref={selectAllCheckboxRef}
                checked={allSelected}
                onCheckedChange={(checked: boolean) => onSelectAll?.(checked === true)}
              />
                  </TableHead>
                )}
                <TableHead>Дата создания</TableHead>
                <TableHead>Номер</TableHead>
                <TableHead>Начальный баланс</TableHead>
                <TableHead>Текущий баланс</TableHead>
                <TableHead>Статус</TableHead>
                <TableHead>Срок действия</TableHead>
                <TableHead>Действия</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {giftCards.map((card) => (
                <GiftCardRow
                  key={card.id}
                  card={card}
                  onEdit={onEdit}
                  onViewTransactions={onViewTransactions}
                  getStatusLabel={getStatusLabel}
                  getStatusClass={getStatusClass}
                  isBulkMode={isBulkMode}
                  isSelected={selectedIds?.has(card.id)}
                  onSelect={onSelect}
                />
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}

